import { Card, Link as DSLink, Icon } from "@icg360/design-system";

import { usePolicyDetail } from "data/ss-data-hooks";
import { getKeyDocs, trackEvent } from "utils";

import styles from "./policy-docs.module.scss";

const DOCUMENTS = {
  currentInvoice: "Current Invoice",
  policyDeclarations: "Policy Declarations",
  invoice: "Invoice",
  policyPackage: "Policy Package",
};

export const PolicyDocs = () => {
  const { data } = usePolicyDetail();
  const keyDocsList = getKeyDocs(
    data?.userDocuments,
    (data?.userBilling?.mortgagees?.length ?? 0) > 0
  );

  return (
    <Card title="Key documents">
      <div className={styles.policyDocuments}>
        Access and print important documents for your personal records or to
        show proof of insurance. If you have questions about the information on
        the policy&apos;s declaration page, please contact your agent for
        assistance.
      </div>
      <div className={styles.cardFooter}>
        {keyDocsList.map(({ label, name, parentId, location }, idx) => (
          <DSLink
            key={idx}
            filename={DOCUMENTS[name]}
            type="PDF"
            name={label}
            className={styles.downloadLink}
            target="_blank"
            href={`/api/policy/${parentId}/${location}`}
            onPress={() => {
              if (name === "policyDeclarations") {
                trackEvent("Declaration Page Link Clicked", {
                  sectionName: "Key Documents",
                });
              }
            }}
          >
            {DOCUMENTS[name]}
            <span className={styles.downloadIcon}>
              <Icon name="Download" size="sm" />
            </span>
          </DSLink>
        ))}
      </div>
    </Card>
  );
};
